export default defineNuxtRouteMiddleware((to) => {
  const isClient = import.meta.client

  // CRITICAL: Check for OAuth params FIRST, before any other logic
  if (isClient && typeof window !== 'undefined') {
    const searchParams = new URLSearchParams(window.location.search)
    const hashParams = new URLSearchParams(window.location.hash.substring(1))

    // Check both query string and hash for OAuth parameters
    const hasOAuthParams =
      (searchParams.has('code') && searchParams.has('state')) || (hashParams.has('code') && hashParams.has('state'))

    // If OAuth callback is present, STOP ALL PROCESSING and let app.vue handle it
    if (hasOAuthParams) {
      return
    }
  }

  // Only check customer authentication if NOT an OAuth callback
  const { isAuthenticated } = useUserStore()

  // Define public routes that don't require authentication
  const publicRoutes = [
    '/login',
    '/admin-token',
    '/register',
    '/forgot-password',
    '/forgot-username',
    '/reset-password',
    '/user/account/activate'
  ]

  const isPublicRoute = (path: string) => {
    return publicRoutes.includes(path) || path.startsWith('/activation/')
  }

  // If not authenticated or no policy and trying to access a protected route, redirect to login
  if (!isAuthenticated && !isPublicRoute(to.path)) {
    return navigateTo({
      path: '/login',
      query: {
        redirect: to.path === '/' || to.path === '/login' ? undefined : to.fullPath
      }
    })
  }

  // If authenticated and trying to access login or register, redirect to home
  if (isAuthenticated && ['/login', '/register'].includes(to.path)) {
    return navigateTo('/')
  }
})
